export enum EXPORT_TAGS {
  wellList = 'WELL_LIST',
  gantt = 'GANTT',
  wellPadPreparations = 'PAD_PREPARATION',
}
